export const JANE_AGENT_LIBRARY = [
    {
        id: 'transcribe-audio',
        title: 'Transcribe audio to text',
        type: 'workflow_agent',
        route: 'audio_transcription',
        route_goal: 'audio_transcription',
        category: 'Audio',
        sourceRequired: 'audio',
        description: 'Upload or link an audio file, and Jane will generate a transcript file.',
        prompt: 'Transcribe the selected audio source to text. Preserve speaker labels and timestamps, save the transcript as a text file next to the original source, and tell me when it is ready.',
        examples: [
            'Transcribe this recorded call and save the transcript to the case.',
            'Transcribe this deposition audio with speaker labels.',
        ],
    },
    {
        id: 'route-general-assistant',
        title: 'Jane response',
        type: 'prompt',
        route: 'general_assistant',
        route_goal: 'general_assistant',
        category: 'General',
        sourceRequired: '',
        description: 'Ask Jane a general question or ask for help planning the next step.',
        prompt: 'Answer the request directly and clearly.',
        examples: [
            'What can you help me with?',
        ],
    },
    {
        id: 'capability-outlook-email-summaries',
        title: 'Outlook email summaries',
        type: 'workflow_agent',
        route: 'general_assistant',
        route_goal: 'general_assistant',
        category: 'Communications',
        sourceRequired: '',
        description: 'Summarize Outlook once, or stage a confirmed daily summary for the whole mailbox or received messages from exact primary-contact senders and case-specific recipients on accessible CaseDB cases.',
        prompt: 'Summarize my received Outlook emails from CaseDB clients from the last 24 hours once now. Include messages sent by an exact primary-contact email or sent to an exact case-specific CaseDB email address on cases I can currently access. Use and cite every matching email in that window, and never broaden to the rest of my mailbox.',
        examples: [
            'Summarize my received Outlook emails from CaseDB clients from the last 24 hours once now.',
            'Create an agent that organizes my emails from clients into a daily summary at 8 AM Central.',
            'Every day at 7:30 AM Central, summarize received Outlook emails from CaseDB clients from the previous 24 hours.',
            'Turn off my daily Outlook summary.',
        ],
    },
    {
        id: 'route-document-retrieval',
        title: 'Document retrieval',
        type: 'prompt',
        route: 'document_retrieval',
        route_goal: 'document_retrieval',
        category: 'Documents',
        sourceRequired: '',
        description: 'Search accessible documents and return source-backed results.',
        prompt: 'Search CaseDB documents for the requested information and cite the supporting sources.',
        examples: [
            'Find the latest demand letter in this case.',
        ],
    },
    {
        id: 'route-direct-file-review',
        title: 'Selected-file review',
        type: 'prompt',
        route: 'direct_file_review',
        route_goal: 'direct_file_review',
        category: 'Documents',
        sourceRequired: 'document',
        description: 'Select one or more files, and Jane will review only those sources.',
        prompt: 'Review the selected file or files and answer the request using those sources.',
        examples: [
            'Summarize this selected PDF.',
        ],
    },
    {
        id: 'route-spreadsheet-analysis',
        title: 'Spreadsheet analysis',
        type: 'prompt',
        route: 'spreadsheet_analysis',
        route_goal: 'spreadsheet_analysis',
        category: 'Reports',
        sourceRequired: 'document',
        description: 'Upload or link a spreadsheet, and Jane will review the data and return the requested output.',
        prompt: 'Analyze the selected spreadsheet and return the requested calculation, summary, or generated file.',
        examples: [
            'Total the settlement column in this spreadsheet.',
        ],
    },
    {
        id: 'route-report-generation',
        title: 'Report generation',
        type: 'workflow_agent',
        route: 'report_generation',
        route_goal: 'report_generation',
        category: 'Reports',
        sourceRequired: '',
        description: 'Describe the report you need, and Jane will prepare the matching CaseDB report.',
        prompt: 'Create the requested CaseDB report from the user request and ask for confirmation before saving.',
        examples: [
            'Create a report of open PI cases by first primary.',
        ],
    },
    {
        id: 'route-legal-draft',
        title: 'Legal document draft',
        type: 'workflow_agent',
        route: 'legal_draft',
        route_goal: 'legal_document_draft',
        category: 'Drafting',
        sourceRequired: 'case',
        description: 'Select a case or source set, and Jane will draft legal work product for review.',
        prompt: 'Draft or revise the requested legal document using the selected case and available sources.',
        examples: [
            'Draft a demand letter for this case.',
        ],
    },
    {
        id: 'route-case-tool',
        title: 'Case tool',
        type: 'prompt',
        route: 'case_tool',
        route_goal: 'case_tool',
        category: 'Case Analysis',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will answer case status, posture, and progress questions.',
        prompt: 'Use the selected case to answer the case status or reasoning question.',
        examples: [
            'What is the posture of this case?',
        ],
    },
    {
        id: 'route-case-documents',
        title: 'Case documents',
        type: 'prompt',
        route: 'case_documents',
        route_goal: 'case_documents',
        category: 'Documents',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will list or inspect the case documents.',
        prompt: 'List or review documents for the selected case.',
        examples: [
            'Give me a list of documents for this case.',
        ],
    },
    {
        id: 'route-feed-lookup',
        title: 'Case feed lookup',
        type: 'prompt',
        route: 'feed_lookup',
        route_goal: 'feed_lookup',
        category: 'Case Analysis',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will review relevant feed or activity updates.',
        prompt: 'Review the selected case feed updates for the requested information.',
        examples: [
            'Show recent activity in this case.',
        ],
    },
    {
        id: 'route-workspace-navigation',
        title: 'Workspace navigation',
        type: 'workflow_agent',
        route: 'workspace_navigation',
        route_goal: 'workspace_navigation',
        category: 'Workspace',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will open or stage work inside the case workspace.',
        prompt: 'Open the requested CaseDB workspace section or stage the requested workspace draft.',
        examples: [
            'Open the case calendar.',
        ],
    },
    {
        id: 'route-medical-chronology',
        title: 'Medical chronology',
        type: 'workflow_agent',
        route: 'medical_chronology',
        route_goal: 'medical_chronology',
        category: 'Medical',
        sourceRequired: 'document',
        description: 'Select medical records, and Jane will plan or build a medical chronology.',
        prompt: 'Create a medical chronology from the selected records or selected case materials.',
        examples: [
            'Create a medical chronology from these records.',
        ],
    },
    {
        id: 'route-appraisal-packet',
        title: 'Appraisal packet',
        type: 'workflow_agent',
        route: 'appraisal_packet',
        route_goal: 'appraisal_packet',
        category: 'Documents',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will recommend or generate appraisal packet materials.',
        prompt: 'Use the selected case to recommend or generate appraisal packet materials.',
        examples: [
            'List recommended appraisal packet documents.',
        ],
    },
    {
        id: 'route-missing-case-data',
        title: 'Missing case data checker',
        type: 'prompt',
        route: 'missing_case_data_checker',
        route_goal: 'missing_case_data_checker',
        category: 'Case Analysis',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will identify missing facts, documents, and next steps.',
        prompt: 'Check what is missing from the selected case. Use the case type to choose the correct readiness checklist, inspect structured case facts/custom fields/field updates and document metadata/text, then return present, missing, and unclear items with evidence and next steps.',
        examples: [
            'What is missing from this case?',
            'Run a readiness check for this case.',
        ],
    },
    {
        id: 'route-sourced-link-timeline',
        title: 'Sourced chronology and timeline',
        type: 'prompt',
        route: 'sourced_link_timeline',
        route_goal: 'sourced_link_timeline',
        category: 'Case Analysis',
        sourceRequired: 'case',
        description: 'Build a cited chronology from selected documents or any requested document type, or create a broad sourced timeline for the case.',
        prompt: 'Build a sourced chronology for the selected case. If I name a document type, preserve that exact scope, find matching active documents first, report coverage and extraction gaps, and include only dated events cited to those documents.',
        examples: [
            'Build a sourced timeline for this case.',
            'Build a chronology of every expert report in this case.',
            'Build a chronology of every roofing estimate in this case.',
            'Build a chronology from the selected documents only.',
        ],
    },
    {
        id: 'route-document-field-extractor',
        title: 'Document field updater',
        type: 'workflow_agent',
        route: 'document_field_extractor',
        route_goal: 'document_field_extractor',
        category: 'Data Entry',
        sourceRequired: 'document_and_case',
        description: 'Select a document and case, and Jane will stage editable field updates.',
        prompt: 'Extract case-field data from the selected document and stage proposed CaseDB field updates for review before saving.',
        examples: [
            'Extract data from this document into the selected case.',
        ],
    },
    {
        id: 'capability-trial-preparation-brief',
        title: 'Trial preparation brief drafting',
        type: 'workflow_agent',
        route: 'legal_draft',
        route_goal: 'legal_document_draft',
        category: 'Drafting',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will draft a trial preparation brief for review.',
        prompt: 'Draft a trial preparation brief for the selected case using available case materials and cited sources.',
        examples: [
            'Prepare this case for trial.',
        ],
    },
    {
        id: 'capability-case-document-filing',
        title: 'Case document filing',
        type: 'workflow_agent',
        route: 'workspace_navigation',
        route_goal: 'workspace_navigation',
        category: 'Documents',
        sourceRequired: 'document_and_case',
        description: 'Select files and a case, and Jane will stage filing them into the case folder.',
        prompt: 'File the selected document into the selected case folder after confirmation.',
        examples: [
            'Save this document to the case folder.',
        ],
    },
    {
        id: 'capability-scheduling-order-calendar',
        title: 'Scheduling-order calendar drafts',
        type: 'workflow_agent',
        route: 'workspace_navigation',
        route_goal: 'workspace_navigation',
        category: 'Calendar',
        sourceRequired: 'document_and_case',
        description: 'Select a scheduling order, and Jane will draft calendar entries for review.',
        prompt: 'Create calendar drafts from the selected scheduling order for the selected case.',
        examples: [
            'Create calendar drafts from this scheduling order.',
        ],
    },
    {
        id: 'capability-calendar-draft-review',
        title: 'Calendar draft review',
        type: 'workflow_agent',
        route: 'workspace_navigation',
        route_goal: 'workspace_navigation',
        category: 'Calendar',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will help review existing calendar drafts.',
        prompt: 'Open and review calendar drafts for the selected case.',
        examples: [
            'Open the case calendar so I can review these drafts.',
        ],
    },
    {
        id: 'capability-artifact-followups',
        title: 'Artifact follow-ups',
        type: 'prompt',
        route: 'legal_draft',
        route_goal: 'legal_document_draft',
        category: 'Drafting',
        sourceRequired: '',
        description: 'Ask Jane to revise, compare, or continue from the current draft or file.',
        prompt: 'Use the current draft or selected artifact as the main source for this follow-up.',
        examples: [
            'Revise the draft you just made.',
        ],
    },
    {
        id: 'capability-drafting-templates',
        title: 'Drafting templates',
        type: 'workflow_agent',
        route: 'legal_draft',
        route_goal: 'legal_document_draft',
        category: 'Drafting',
        sourceRequired: 'case',
        description: 'Select a case, and Jane will use the best matching drafting template.',
        prompt: 'Use the best matching drafting template for the selected case and preserve unsupported placeholders.',
        examples: [
            'Use the demand template for this case.',
        ],
    },
    {
        id: 'capability-document-comparison',
        title: 'Document comparison',
        type: 'prompt',
        route: 'direct_file_review',
        route_goal: 'direct_file_review',
        category: 'Documents',
        sourceRequired: 'document',
        description: 'Select documents, and Jane will compare them with source support.',
        prompt: 'Compare the selected documents and cite the source support for material differences.',
        examples: [
            'Compare these two documents.',
        ],
    },
    {
        id: 'capability-chat-workflow',
        title: 'Chat workflow',
        type: 'prompt',
        route: 'general_assistant',
        route_goal: 'general_assistant',
        category: 'General',
        sourceRequired: '',
        description: 'Use Jane chat features like reruns, forks, source context, and follow-ups.',
        prompt: 'Help manage this Jane chat workflow.',
        examples: [
            'Fork this chat before changing direction.',
        ],
    },
    {
        id: 'capability-tool-library',
        title: 'Tool library',
        type: 'prompt',
        route: 'general_assistant',
        route_goal: 'general_assistant',
        category: 'General',
        sourceRequired: '',
        description: 'Ask Jane what tools are available and how to use them.',
        prompt: 'Show the available Jane tools and suggest the best one for the request.',
        examples: [
            'What can Jane do?',
        ],
    },
    {
        id: 'capability-context-visibility',
        title: 'Context visibility',
        type: 'prompt',
        route: 'general_assistant',
        route_goal: 'general_assistant',
        category: 'General',
        sourceRequired: '',
        description: 'Inspect what Jane used, including sources, context, and route details.',
        prompt: 'Explain what context, sources, and route were used for this Jane response.',
        examples: [
            'What sources did Jane use?',
        ],
    },
];

export const JANE_AGENT_LIBRARY_CATEGORIES = Array.from(new Set(JANE_AGENT_LIBRARY.map(agent => agent.category))).sort();

export const JANE_AGENT_LIBRARY_STORAGE_KEY = 'jane-agent-library-saved-agents-v1';
export const JANE_AGENT_LIBRARY_PINNED_STORAGE_KEY = 'jane-agent-library-pinned-agents-v1';

export const loadSavedJaneAgents = () => {
    if (typeof window === 'undefined') return [];
    try {
        const parsed = JSON.parse(window.localStorage.getItem(JANE_AGENT_LIBRARY_STORAGE_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.filter(agent => agent && typeof agent === 'object') : [];
    } catch (error) {
        return [];
    }
};

export const saveSavedJaneAgents = (agents = []) => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(JANE_AGENT_LIBRARY_STORAGE_KEY, JSON.stringify(Array.isArray(agents) ? agents : []));
};

export const loadPinnedJaneAgentIds = () => {
    if (typeof window === 'undefined') return [];
    try {
        const parsed = JSON.parse(window.localStorage.getItem(JANE_AGENT_LIBRARY_PINNED_STORAGE_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
    } catch (error) {
        return [];
    }
};

export const savePinnedJaneAgentIds = (agentIds = []) => {
    if (typeof window === 'undefined') return;
    const normalized = Array.from(new Set((Array.isArray(agentIds) ? agentIds : []).map(String).filter(Boolean)));
    window.localStorage.setItem(JANE_AGENT_LIBRARY_PINNED_STORAGE_KEY, JSON.stringify(normalized));
};

export const buildSavedJaneAgent = ({ title = '', prompt = '', category = 'Saved', type = 'prompt' }) => ({
    id: `saved-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`,
    title: String(title || '').trim() || 'Saved Jane prompt',
    type,
    category,
    sourceRequired: '',
    description: 'Saved from your Jane composer.',
    prompt: String(prompt || '').trim(),
    examples: [],
    saved: true,
    tool: 'Saved prompt',
    creator: 'You',
    created_at: new Date().toISOString(),
});

export const getJaneAgentSourceRequirementLabel = (sourceRequired = '') => {
    switch (sourceRequired) {
        case 'audio':
            return 'Needs an audio/video source';
        case 'case':
            return 'Needs a case';
        case 'document':
            return 'Needs a document';
        case 'document_and_case':
            return 'Needs a document and case';
        default:
            return 'No required source';
    }
};

export const isJaneAgentSourceReady = (agent, references = []) => {
    const requirement = agent?.sourceRequired || '';
    if (!requirement) return true;
    const hasCase = references.some(reference => reference?.type === 'case' && Number(reference.case_id || reference.id) > 0);
    const hasFile = references.some(reference => Number(reference?.file_id) > 0);
    const hasAudio = references.some((reference) => {
        const name = String(reference?.file_name || reference?.name || reference?.label || '').toLowerCase();
        return Number(reference?.file_id) > 0 && /\.(mp3|mp4|m4a|wav|flac|ogg|amr|webm)$/i.test(name);
    });
    if (requirement === 'audio') return hasAudio;
    if (requirement === 'case') return hasCase;
    if (requirement === 'document') return hasFile;
    if (requirement === 'document_and_case') return hasCase && hasFile;
    return true;
};

export const buildJaneAgentPrompt = (agent, references = []) => {
    const basePrompt = String(agent?.prompt || '').trim();
    if (!basePrompt) return '';
    const sourceLabels = references
        .map(reference => String(reference?.label || reference?.file_name || reference?.name || reference?.case_name || '').trim())
        .filter(Boolean)
        .slice(0, 5);
    if (sourceLabels.length === 0) return basePrompt;
    return `${basePrompt}\n\nSelected context: ${sourceLabels.join('; ')}.`;
};
